import React from "react";
import ProtectedRoute from "routes/ProtectedRoute";
import { protectedRouteLoader } from "routes/loaders/protectedRouteLoader";

const ticketsRoute = [
  {
    path: "",
    loader: protectedRouteLoader,

    // Lazy-load AdminLayout wrapper
    lazy: async () => {
      const mod = await import("components/UI/AdminLayout");
      const AdminLayout = mod.default;

      return {
        Component: () => (
          <ProtectedRoute>
            <AdminLayout />
          </ProtectedRoute>
        ),
      };
    },

    children: [
      {
        path: "tickets",
        lazy: async () => {
          const mod = await import("views/Admin/Tickets/UserTickets");
          const UserTickets = mod.UserTickets;

          return {
            Component: () => (
              <ProtectedRoute>
                <UserTickets />
              </ProtectedRoute>
            ),
          };
        },
      },
    ],
  },
];

export default ticketsRoute;
